// import React from 'react';
import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/familias';

const familiasApi = {
    crear: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/crear`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching informacion de creacion de familia:', error);
        return [];
    }
},

    detalle: async ( id : string ) => {
        try {
            const response = await axios.get(`${BASE_URL}/${id}`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching informacion de creacion de familia:', error);
        return [];
    }
},

    editar: async ( id : string ) => {
        try {
            const response = await axios.get(`${BASE_URL}/editar/${id}`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching informacion de edicion de familia:', error);
        return [];
    }
},

    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching familias:', error);
        return [];
    }
},

    baja: async ( id : string ) => {
        try {
            const response = await axios.get(`${BASE_URL}/baja/${id}`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de edicion de familia:', error);
            return [];
        }
    },


};

export default familiasApi;